import AudienceInfo from "@/components/AudienceInfo";
import recruitersStory from "@/assets/recruiters-story.png";

export default function ForRecruiters() {
  return (
    <AudienceInfo
      testid="for-recruiters-page"
      tag="Recruiters & agencies"
      image={recruitersStory}
      imageAlt="From too many roles and CVs to clear shortlists and better client matches in one workspace"
      title="Match client roles to candidates who fit the conditions."
      promise="Not 800 CVs — the smaller group of candidates who genuinely meet each client role's real requirements. The same eligibility and matching engine, across all your clients."
      bullets={[
        "Manage multiple clients and roles from one workspace.",
        "Run every role through the same explainable eligibility + match engine.",
        "See why each candidate fits or doesn't — no opaque scores.",
        "Later: white-label portal, embeddable widget and API for your own site.",
      ]}
      note="The recruiter workspace (clients, candidate pools, shortlists) and white-label options arrive after Phase 2B."
    />
  );
}
